export class ColumnMappingModel {
    columnList: any;
    docPath: any;
    docName: any;
}
